import React, { Component } from 'react';
import styled from 'styled-components';
import { rgba } from 'polished';
import { getTheme, getVars, screen } from '../../global/utils';
const CardWrapper = styled.div`
  background-color: ${getTheme('bg', 'light1')};
  border-radius: ${getTheme('radius', 'm')};
  padding: ${getTheme('spacer', 'xl')};
  box-shadow: 0 8px 16px ${rgba(getVars('black', '_50'), 0.1)};

  @media (max-width: ${screen('smMax')}) {
    padding: ${getTheme('spacer', 'l')};
  }

  .card__content {
    :last-child {
      margin-bottom: 0;
    }
  }

  .card__footer {
    margin: ${getTheme('spacer', 'l')} -${getTheme('spacer', 'xl')} -${getTheme(
        'spacer',
        'xl'
      )};
    @media (max-width: ${screen('smMax')}) {
      margin: ${getTheme('spacer', 'm')} -${getTheme('spacer', 'l')} -${getTheme(
          'spacer',
          'l'
        )};
    }
    > :last-child {
      margin-bottom: 0;
    }
  }
`;

class Card extends Component {
  render() {
    let cardFooterWrapper;
    if (this.props.cardFooter) {
      cardFooterWrapper = (
        <div className="card__footer">{this.props.cardFooter}</div>
      );
    }
    return (
      <CardWrapper className={this.props.className}>
        <div className="card__content">{this.props.children}</div>
        {cardFooterWrapper}
      </CardWrapper>
    );
  }
}

export default Card;



// WEBPACK FOOTER //
// ./src/components/cards/Card.js